"use client";

// shouldn't be called from server side
import qs from "query-string";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import { RootState } from "../../interfaces/generics.type";
import { IFitmentOption } from "../../interfaces/session/IVehicle";
import { getOrCreateStore } from "../../modules/lib/with-redux-store";
import { getFitmentOptionQS } from "../vehicle/get-fitment-option-q-s";
import { enocdeStr } from "./urlHelper";

export function getNextQuery(query = {}) {
  let parsedQuery = typeof query === "string" ? qs.parse(query) : { ...query };
  let fo = "";
  if (getOrCreateStore()) {
    const store: RootState = getOrCreateStore().getState();
    const { selectedVehicle } = store.garage;
    const { businessCustomer } = store.authenticationState;
    if (selectedVehicle && validateVehicle(selectedVehicle)) {
      const {
        make, model, year, fitmentOptions,
      } = selectedVehicle || {};
      const encodedFitmentOptions: IFitmentOption[] = fitmentOptions ? fitmentOptions.map((f) => ({
        ...f,
        optionValue: enocdeStr(f.optionValue),
      })) : [];
      const fitmentString = getFitmentOptionQS(encodedFitmentOptions);
      fo = fitmentString && `&${fitmentString}`;
      const nextQuery = {
        ...(make && { selectedMake: make }),
        ...(model && { selectedModel: model }),
        ...(year && { selectedYear: year }),
      };
      parsedQuery = { ...parsedQuery, ...nextQuery };
    }
    if (businessCustomer) {
      parsedQuery.businessCustomer = businessCustomer;
    }
  }
  parsedQuery.isCSR = true;
  return qs.stringify(parsedQuery) + fo;
}
